import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export type EditDeviceMutationParams = {
	id: number;
	name: string;
};

export const createEditDeviceMutation = () =>
	createAuthMutation({
		params: declareParams<EditDeviceMutationParams>(),
		request: {
			method: 'PATCH',
			url: (params) => `/device/${params.id}`,
			body: (data) => ({
				name: data.name,
			}),
		},
		response: {
			contract: zodContract(entityWithNameSchema),
		},
	});
